import { Grid } from "@mui/material";
import DummyCard from "./DummyCard";

export default function DummyDashboard() {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <DummyCard />
        </Grid>
        <Grid item xs={12} md={3}>
          <DummyCard />
        </Grid>
        <Grid item xs={12} md={3}>
          <DummyCard />
        </Grid>
        <Grid item xs={12} md={3}>
          <DummyCard />
        </Grid>
      </Grid>
    );
}